angular.module('rjmNg.constants')
.constant('emailSummaryEnums',
  STATUS: Object.freeze(
    DELETED: 0
    ACTIVE: 1
    PAUSED: 2
  ),
  HOURS: Object.freeze(
    0: "Midnight"
    1: "1:00 AM"
    2: "2:00 AM"
    3: "3:00 AM"
    4: "4:00 AM"
    5: "5:00 AM"
    6: "6:00 AM"
    7: "7:00 AM"
    8: "8:00 AM"
    9: "9:00 AM"
    10: "10:00 AM"
    11: "11:00 AM"
    12: "Noon"
    13: "1:00 PM"
    14: "2:00 PM"
    15: "3:00 PM"
    16: "4:00 PM"
    17: "5:00 PM"
    18: "6:00 PM"
    19: "7:00 PM"
    20: "8:00 PM"
    21: "9:00 PM"
    22: "10:00 PM"
    23: "11:00 PM"
  ),
  FREQUENCIES: Object.freeze(
    1: "Every Sunday"
    2: "Every Monday"
    3: "Every Tuesday"
    4: "Every Wednesday"
    5: "Every Thursday"
    6: "Every Friday"
    7: "Every Saturday"
    8: "Every Day"
    9: "Weekdays"
    10: "First Day of the Month"
    11: "Last Day of the Month"
  ),
  NEW_FREQUENCIES: Object.freeze(
    MANUAL: 0
    ONCE: 1
    DAILY: 2
    WEEKLY: 3
    MONTHLY: 4
    QUARTERLY: 5
    YEARLY: 6
  ),
  STATUSES: Object.freeze(
    DELETED: 0
    ACTIVE: 1
    PAUSED: 2
  ),
  STATUSE_NAMES: Object.freeze(
    0: "Deleted"
    1: "Active"
    2: "Paused"
  ),
  HOUR_OPTIONS: Object.freeze([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  MINUTE_OPTIONS: Object.freeze(['00', '30']),
  AM_PM_OPTIONS: Object.freeze(['AM', 'PM']),
  EMAIL_REGEXP: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/,
  SPLIT_SYMBOLS_REGEXP: /(?:\\b|\\f|\\n|\\r|\\t|\\v|,|;|\s)+/g,
  MAX_RECIPIENTS_NUMBER: 100,
  MAX_EMAIL_LENGTH: 255
)
